"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencySymbolsMap = void 0;
var CurrencySymbolsMap;
(function (CurrencySymbolsMap) {
    CurrencySymbolsMap["AED"] = "\u062F.\u0625";
    CurrencySymbolsMap["AFN"] = "\u060B";
    CurrencySymbolsMap["ALL"] = "L";
    CurrencySymbolsMap["AMD"] = "\u058F";
    CurrencySymbolsMap["ANG"] = "\u0192";
    CurrencySymbolsMap["AOA"] = "Kz";
    CurrencySymbolsMap["ARS"] = "$";
    CurrencySymbolsMap["AUD"] = "$";
    CurrencySymbolsMap["AWG"] = "\u0192";
    CurrencySymbolsMap["AZN"] = "\u20BC";
    CurrencySymbolsMap["BAM"] = "KM";
    CurrencySymbolsMap["BBD"] = "$";
    CurrencySymbolsMap["BDT"] = "\u09F3";
    CurrencySymbolsMap["BGN"] = "\u043B\u0432";
    CurrencySymbolsMap["BHD"] = ".\u062F.\u0628";
    CurrencySymbolsMap["BIF"] = "FBu";
    CurrencySymbolsMap["BMD"] = "$";
    CurrencySymbolsMap["BND"] = "$";
    CurrencySymbolsMap["BOB"] = "$b";
    CurrencySymbolsMap["BOV"] = "BOV";
    CurrencySymbolsMap["BRL"] = "R$";
    CurrencySymbolsMap["BSD"] = "$";
    CurrencySymbolsMap["BTC"] = "\u20BF";
    CurrencySymbolsMap["BTN"] = "Nu.";
    CurrencySymbolsMap["BWP"] = "P";
    CurrencySymbolsMap["BYN"] = "Br";
    CurrencySymbolsMap["BYR"] = "Br";
    CurrencySymbolsMap["BZD"] = "BZ$";
    CurrencySymbolsMap["CAD"] = "$";
    CurrencySymbolsMap["CDF"] = "FC";
    CurrencySymbolsMap["CHE"] = "CHE";
    CurrencySymbolsMap["CHF"] = "CHF";
    CurrencySymbolsMap["CHW"] = "CHW";
    CurrencySymbolsMap["CLF"] = "CLF";
    CurrencySymbolsMap["CLP"] = "$";
    CurrencySymbolsMap["CNH"] = "\u00A5";
    CurrencySymbolsMap["CNY"] = "\u00A5";
    CurrencySymbolsMap["COP"] = "$";
    CurrencySymbolsMap["COU"] = "COU";
    CurrencySymbolsMap["CRC"] = "\u20A1";
    CurrencySymbolsMap["CUC"] = "$";
    CurrencySymbolsMap["CUP"] = "\u20B1";
    CurrencySymbolsMap["CVE"] = "$";
    CurrencySymbolsMap["CZK"] = "K\u010D";
    CurrencySymbolsMap["DJF"] = "Fdj";
    CurrencySymbolsMap["DKK"] = "kr";
    CurrencySymbolsMap["DOP"] = "RD$";
    CurrencySymbolsMap["DZD"] = "\u062F\u062C";
    CurrencySymbolsMap["EEK"] = "kr";
    CurrencySymbolsMap["EGP"] = "\u00A3";
    CurrencySymbolsMap["ERN"] = "Nfk";
    CurrencySymbolsMap["ETB"] = "Br";
    CurrencySymbolsMap["ETH"] = "\u039E";
    CurrencySymbolsMap["EUR"] = "\u20AC";
    CurrencySymbolsMap["FJD"] = "$";
    CurrencySymbolsMap["FKP"] = "\u00A3";
    CurrencySymbolsMap["GBP"] = "\u00A3";
    CurrencySymbolsMap["GEL"] = "\u20BE";
    CurrencySymbolsMap["GGP"] = "\u00A3";
    CurrencySymbolsMap["GHC"] = "\u20B5";
    CurrencySymbolsMap["GHS"] = "GH\u20B5";
    CurrencySymbolsMap["GIP"] = "\u00A3";
    CurrencySymbolsMap["GMD"] = "D";
    CurrencySymbolsMap["GNF"] = "FG";
    CurrencySymbolsMap["GTQ"] = "Q";
    CurrencySymbolsMap["GYD"] = "$";
    CurrencySymbolsMap["HKD"] = "$";
    CurrencySymbolsMap["HNL"] = "L";
    CurrencySymbolsMap["HRK"] = "kn";
    CurrencySymbolsMap["HTG"] = "G";
    CurrencySymbolsMap["HUF"] = "Ft";
    CurrencySymbolsMap["IDR"] = "Rp";
    CurrencySymbolsMap["ILS"] = "\u20AA";
    CurrencySymbolsMap["IMP"] = "\u00A3";
    CurrencySymbolsMap["INR"] = "\u20B9";
    CurrencySymbolsMap["IQD"] = "\u0639.\u062F";
    CurrencySymbolsMap["IRR"] = "\uFDFC";
    CurrencySymbolsMap["ISK"] = "kr";
    CurrencySymbolsMap["JEP"] = "\u00A3";
    CurrencySymbolsMap["JMD"] = "J$";
    CurrencySymbolsMap["JOD"] = "JD";
    CurrencySymbolsMap["JPY"] = "\u00A5";
    CurrencySymbolsMap["KES"] = "KSh";
    CurrencySymbolsMap["KGS"] = "\u043B\u0432";
    CurrencySymbolsMap["KHR"] = "\u17DB";
    CurrencySymbolsMap["KMF"] = "CF";
    CurrencySymbolsMap["KPW"] = "\u20A9";
    CurrencySymbolsMap["KRW"] = "\u20A9";
    CurrencySymbolsMap["KWD"] = "KD";
    CurrencySymbolsMap["KYD"] = "$";
    CurrencySymbolsMap["KZT"] = "\u20B8";
    CurrencySymbolsMap["LAK"] = "\u20AD";
    CurrencySymbolsMap["LBP"] = "\u00A3";
    CurrencySymbolsMap["LKR"] = "\u20A8";
    CurrencySymbolsMap["LRD"] = "$";
    CurrencySymbolsMap["LSL"] = "M";
    CurrencySymbolsMap["LTC"] = "\u0141";
    CurrencySymbolsMap["LTL"] = "Lt";
    CurrencySymbolsMap["LVL"] = "Ls";
    CurrencySymbolsMap["LYD"] = "LD";
    CurrencySymbolsMap["MAD"] = "MAD";
    CurrencySymbolsMap["MDL"] = "lei";
    CurrencySymbolsMap["MGA"] = "Ar";
    CurrencySymbolsMap["MKD"] = "\u0434\u0435\u043D";
    CurrencySymbolsMap["MMK"] = "K";
    CurrencySymbolsMap["MNT"] = "\u20AE";
    CurrencySymbolsMap["MOP"] = "MOP$";
    CurrencySymbolsMap["MRO"] = "UM";
    CurrencySymbolsMap["MRU"] = "UM";
    CurrencySymbolsMap["MUR"] = "\u20A8";
    CurrencySymbolsMap["MVR"] = "Rf";
    CurrencySymbolsMap["MWK"] = "MK";
    CurrencySymbolsMap["MXN"] = "$";
    CurrencySymbolsMap["MXV"] = "MXV";
    CurrencySymbolsMap["MYR"] = "RM";
    CurrencySymbolsMap["MZN"] = "MT";
    CurrencySymbolsMap["NAD"] = "$";
    CurrencySymbolsMap["NGN"] = "\u20A6";
    CurrencySymbolsMap["NIO"] = "C$";
    CurrencySymbolsMap["NOK"] = "kr";
    CurrencySymbolsMap["NPR"] = "\u20A8";
    CurrencySymbolsMap["NZD"] = "$";
    CurrencySymbolsMap["OMR"] = "\uFDFC";
    CurrencySymbolsMap["PAB"] = "B/.";
    CurrencySymbolsMap["PEN"] = "S/.";
    CurrencySymbolsMap["PGK"] = "K";
    CurrencySymbolsMap["PHP"] = "\u20B1";
    CurrencySymbolsMap["PKR"] = "\u20A8";
    CurrencySymbolsMap["PLN"] = "z\u0142";
    CurrencySymbolsMap["PYG"] = "Gs";
    CurrencySymbolsMap["QAR"] = "\uFDFC";
    CurrencySymbolsMap["RMB"] = "\uFFE5";
    CurrencySymbolsMap["RON"] = "lei";
    CurrencySymbolsMap["RSD"] = "\u0414\u0438\u043D.";
    CurrencySymbolsMap["RUB"] = "\u20BD";
    CurrencySymbolsMap["RWF"] = "R\u20A3";
    CurrencySymbolsMap["SAR"] = "\uFDFC";
    CurrencySymbolsMap["SBD"] = "$";
    CurrencySymbolsMap["SCR"] = "\u20A8";
    CurrencySymbolsMap["SDG"] = "\u062C.\u0633.";
    CurrencySymbolsMap["SEK"] = "kr";
    CurrencySymbolsMap["SGD"] = "S$";
    CurrencySymbolsMap["SHP"] = "\u00A3";
    CurrencySymbolsMap["SLL"] = "Le";
    CurrencySymbolsMap["SOS"] = "S";
    CurrencySymbolsMap["SRD"] = "$";
    CurrencySymbolsMap["SSP"] = "\u00A3";
    CurrencySymbolsMap["STD"] = "Db";
    CurrencySymbolsMap["STN"] = "Db";
    CurrencySymbolsMap["SVC"] = "$";
    CurrencySymbolsMap["SYP"] = "\u00A3";
    CurrencySymbolsMap["SZL"] = "E";
    CurrencySymbolsMap["THB"] = "\u0E3F";
    CurrencySymbolsMap["TJS"] = "SM";
    CurrencySymbolsMap["TMT"] = "T";
    CurrencySymbolsMap["TND"] = "\u062F.\u062A";
    CurrencySymbolsMap["TOP"] = "T$";
    CurrencySymbolsMap["TRL"] = "\u20A4";
    CurrencySymbolsMap["TRY"] = "\u20BA";
    CurrencySymbolsMap["TTD"] = "TT$";
    CurrencySymbolsMap["TVD"] = "$";
    CurrencySymbolsMap["TWD"] = "NT$";
    CurrencySymbolsMap["TZS"] = "TSh";
    CurrencySymbolsMap["UAH"] = "\u20B4";
    CurrencySymbolsMap["UGX"] = "USh";
    CurrencySymbolsMap["USD"] = "$";
    CurrencySymbolsMap["UYI"] = "UYI";
    CurrencySymbolsMap["UYU"] = "$U";
    CurrencySymbolsMap["UYW"] = "UYW";
    CurrencySymbolsMap["UZS"] = "\u043B\u0432";
    CurrencySymbolsMap["VEF"] = "Bs";
    CurrencySymbolsMap["VES"] = "Bs.S";
    CurrencySymbolsMap["VND"] = "\u20AB";
    CurrencySymbolsMap["VUV"] = "VT";
    CurrencySymbolsMap["WST"] = "WS$";
    CurrencySymbolsMap["XAF"] = "FCFA";
    CurrencySymbolsMap["XBT"] = "\u0243";
    CurrencySymbolsMap["XCD"] = "$";
    CurrencySymbolsMap["XOF"] = "CFA";
    CurrencySymbolsMap["XPF"] = "\u20A3";
    CurrencySymbolsMap["XSU"] = "Sucre";
    CurrencySymbolsMap["XUA"] = "XUA";
    CurrencySymbolsMap["YER"] = "\uFDFC";
    CurrencySymbolsMap["ZAR"] = "R";
    CurrencySymbolsMap["ZMW"] = "ZK";
    CurrencySymbolsMap["ZWD"] = "Z$";
    CurrencySymbolsMap["ZWL"] = "$";
})(CurrencySymbolsMap = exports.CurrencySymbolsMap || (exports.CurrencySymbolsMap = {}));
//# sourceMappingURL=data:application/json;base64,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